import React from 'react';
import Customer from './customer';
import Agent from './agent';
import './../style/style.css';
import {joinCall} from './../service.js';
import Div100vh from 'react-div-100vh';
import {isAndroid, isIOS, isChrome, isFirefox, isSafari, isMobileSafari, isEdgeChromium, isEdge} from 'react-device-detect';
import autosize from "autosize";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LanguageChange from './language';

class AppComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      callid: "",
      isCustomer: true,
      callState: "notvalidated",
      agent: "",
      isConnected : navigator.onLine,
      showcopied: false,
      errorcode: 0
    };
    this.handleConnectionChange = this.handleConnectionChange.bind(this);
  }

  componentWillMount() {
    const query = new window.URLSearchParams(window.location.search);
    console.log(query.get("token"));
    console.log(!query.get("agent"));
    this.setState({
      isCustomer: !query.get("agent"),
      token: query.get("token"),
      agent: query.get("agent")
    });
    
  }

  componentDidMount(){
    autosize(this.textAreaRef);
    window.addEventListener('online', this.handleConnectionChange);
    window.addEventListener('offline', this.handleConnectionChange);      
  }

  handleConnectionChange(event){
    console.log("Connection Change "+event.type);
    this.setState({isConnected : navigator.onLine })
  }  
  
  componentWillUnmount(){
    window.removeEventListener('online', this.handleConnectionChange);
    window.removeEventListener('offline', this.handleConnectionChange);
  }
  

  render() {
    const browser = this.checkBrowser();
    const { t } = this.props;
    if (browser.valid) {
      if (this.state.callState === "notvalidated") {
        return (
          <Div100vh>
            {!this.state.isConnected?<div className="Reconnecting">{t("network_disconnected")}</div>:null}
            <div className="PageTitle">
              <div className="Header">{t('videophone_title')}</div>
            </div>
            <ToastContainer />
            <div className="BodyStyle">
              {!this.state.isCustomer && <div className="JoinButtonWrapper">
                <button
                  className="JoinButtonStyle"
                  onClick={event => {
                    this.handleJoinCall();
                  }}
                  id="join_id"
                >
                  {t("call_join")}
                </button>
              </div>}
              {this.state.isCustomer && <div className="JoinButtonWrapperText">
                <div id="join_yes"  onClick={()=>{
                console.log("Clicked Yes")
                this.handleJoinCall();
              }} > 
              <div  className="JoinButtonStyle"> 
                <div style={{color:"white", textAlign:"center",   fontWeight: "bold"}}>{t("yes")}</div>
                <br />
                <div style={{color:"white", textAlign:"center"}}>{t("join_yes_confirm")}</div>
                <br />
                <div style={{color:"white", textAlign:"center"}}>{t("join_yes_confirm_2")}</div>
                <br />
                </div>
                </div>
              </div>}  

              {this.state.isCustomer && <div className="JoinButtonWrapperTextNo">
                <div id="join_no" style={{color:"white", textAlign:"center",  textDecoration: "underline", padding:"2%"}}
                  onClick={()=>{
                    console.log("No  clicked")
                    this.handleClose();
                  }}
                >
                  <span style={{ fontWeight: "bold"}}>{t("no")}
                </span> <span>{t("join_no_text")}</span></div>

              </div>}               

              <div className="langselector">
                <LanguageChange />     
              </div>
            </div>
          </Div100vh>
        );
      } else if (
        this.state.callState === "invalid" ||
        this.state.callState === "ended"
      ) {
        return (
          <Div100vh>
            <div className="PageTitle">
              <div className="Header">{t('videophone_title')}</div>
            </div>
            <div className="BodyStyle">
              <div className="BodyTextApp">
              {t('invalid_expired_call_url')} {":"+this.state.errorcode}
              </div>
              <div style={{position:"absolute", bottom : "5%"}} className="langselector">
                <LanguageChange />     
              </div>               
            </div>
          </Div100vh>
        );
      }else if (this.state.callState === "user_close"){
        return (
          <Div100vh>
            <div className="PageTitle">
              <div className="Header">{t('videophone_title')}</div>
            </div>
            <div className="BodyStyle">
              <div className="BodyTextApp">
              {t('close_tab')}
              </div>
            </div>
          </Div100vh>
        );
      } else {
        if (this.state.isCustomer) {
          return (
            <Div100vh>
              <Customer
                callID={this.state.callid}
                token={this.state.token}
                callStatus={this.state.callStatus}
                isCustomer={this.state.isCustomer}
                t={this.props.t}
              />
            </Div100vh>
          );
        } else {
          return (
            <Div100vh>
              <Agent
                callID={this.state.callid}
                token={this.state.token}
                callStatus={this.state.callStatus}
                isCustomer={this.state.isCustomer}
                t={this.props.t}
              />
            </Div100vh>
          );
        }
      }
    } else {
      return (
        <Div100vh>
          <div className="PageTitle">
            <div className="Header">{t('videophone_title')}</div>
          </div>
          <div className="BodyStyle">
            <div className="BodyTextApp">{browser.message }<br /><br />{ t("copy_help")}</div>
              <div style={{ "width": "100%", "display": "flex", "justifyContent": "center", "alignItems": "center" }}>
                <div
                  id="selection"
                  className="textArea"
                  ref={(ref) => {
                    this.textAreaRef = ref;
                  }}
                  onClick={(event) => {
                    this.selectText("selection");
                  }}
              >
                {window.location.href}
                </div>
              </div>
              {this.state.showcopied ? 
              <div style={{ "width": "100%", "display": "flex", "justifyContent": "center", "alignItems": "center" , padding:"1vw"}} >
                <span className="copiedText">{t('copied')}</span>
              </div>: null}
              <div style={{position:"absolute", bottom : "5%"}} className="langselector">
                <LanguageChange />     
              </div>                
          </div>
        </Div100vh>
      );
    }
  }

  
selectText(containerid) {
  var range;
  if (document.selection) { // IE
      range = document.body.createTextRange();
      range.moveToElementText(document.getElementById(containerid));
      range.select();
      document.execCommand("Copy");
  } else if (window.getSelection) {
      range = document.createRange();
      range.selectNode(document.getElementById(containerid));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("Copy");
  }
  this.setState({showcopied:true});
  setTimeout(()=>{this.setState({showcopied:false});}, 5000);
}

handleClose=()=>{
    this.setState({callState : "user_close"});
}

  handleJoinCall(event) {
    joinCall(this.state.token, this.state.agent, (status, data, errorcode) => {
      let localErrorCode = 0;
      try{
        localErrorCode = parseInt(errorcode, 10);
      }catch(err){

      }
      if(status){
        this.setState({
          callState: "validated",
          callid: data
        });
      }else{
        if(data !== -1){
          this.setState({
            callState:  "invalid",
            callid: data,
            errorcode: localErrorCode
          });
        }else{
          toast(this.props.t("network_check")+localErrorCode, {
            type: toast.TYPE.ERROR,
            autoClose: 2000,
            closeButton: null // The closeButton defined on ToastContainer will be used
          });
        }
      }
    });
  }

  checkBrowser() {
    console.log("isEdgeChromium",isEdgeChromium, "isEdge", isEdge);
    const result = {};
    let str = this.props.t("browser_error")
    if(str === "browser_error"){
        result.valid = true;
        return  result;
    }
    let str_split1 = str.split("<");
    let _str_split2 = str_split1[1].split(">");
    if (isAndroid) {
      if (isChrome || isFirefox || isEdgeChromium) {
        result.valid = true;
      } else {
        result.valid = false;
        result.message = str_split1[0]+ " Chrome/Firefox/Edge "+_str_split2[1];
//          "Please use Chrome or Firefox browser to join this call";
      }
      return result;
    }

    if (isIOS) {
      if (isSafari || isMobileSafari) {
        result.valid = true;
      } else {
        result.valid = false;
        result.message = str_split1[0]+ " Safari "+_str_split2[1]; //"Please use Safari browser to join this call";
      }
      return result;
    }

    if (this.getOS() === "Mac OS") {
      if (isFirefox || isChrome) {
        result.valid = true;
      } else {
        result.valid = false;
        result.message = str_split1[0]+ " Firefox/Chrome "+_str_split2[1]; 
         // "Please use Firefox or Chrome browser to join this call";
      }
      return result;
    }

    if (this.getOS() === "Windows") {
      if (isSafari || isFirefox || isChrome || isEdgeChromium) {
        result.valid = true;
      } else {
        result.valid = false;
        result.message =  str_split1[0]+ " Firefox/Chrome/Edge "+_str_split2[1]; 
         // "Please use Firefox or Chrome or edge browser to join this call";
      }
      return result;
    }

    if (this.getOS() === "Linux") {
      if (isSafari || isFirefox || isChrome || isEdgeChromium) {
        result.valid = true;
      } else {
        result.valid = false;
        result.message =  str_split1[0]+ " Firefox/Chrome/Edge "+_str_split2[1]; 
          //"Please use Firefox or Chrome browser to join this call";
      }
      return result;
    }

    result.valid = false;
    result.message = this.props.t("browser_not_supported");
    console.log("UseerAgent " + window.navigator.userAgent);
    console.log("platform " + window.navigator.platform);
    return result;
  }

  getOS() {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
      windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
      iosPlatforms = ["iPhone", "iPad", "iPod"],
      os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = "Mac OS";
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = "iOS";
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = "Windows";
    } else if (/Android/.test(userAgent)) {
      os = "Android";
    } else if (!os && /Linux/.test(platform)) {
      os = "Linux";
    }

    return os;
  }
}


export default AppComponent;

